import React, { Component } from 'react'
import './index.less'

import RewardItem from '../RewardItem'

export default class extends Component {
  render() {
    const { list, title, topBg, centerBg, bottomBg } = this.props
    return (
      list &&
      list.length > 0 && (
        <div className="nt-reward-wrap" style={{ backgroundImage: `url(${centerBg})` }}>
          <div className="nt-top-bg" style={{ backgroundImage: `url(${topBg})` }}></div>
          <div className="nt-bottom-bg" style={{ backgroundImage: `url(${bottomBg})` }}></div>
          <div className="nt-reward-title">{title}</div>
          <div className="nt-items">
            {list &&
              list.map((item, index) => {
                return <RewardItem key={index} name={item.name} img={item.image} />
              })}
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Reward/index.js